// extracted by mini-css-extract-plugin
export default {"containerr":"yiS5s8","mobile":"ffVChd","loader":"FVDlRz","button":"OaUYT1","loading":"OFyGQZ","full":"QqYl8W","rounded":"gtE3u9"};